// Memory only: customer/order data must never persist in browser storage.
const ORDER_LIST_CACHE_TTL_MS = 5 * 60 * 1000;
const entries = new Map();
let generation = 0;
export const ORDERS_CHANGED = "oss-orders-changed";
export function clearOrderListCache() {
  entries.clear();
  generation++;
  window.dispatchEvent(new Event(ORDERS_CHANGED));
}
export function getOrderCacheGeneration() { return generation; }
export function getOrderListEntry(key) {
  let entry = entries.get(key);
  if (!entry || Date.now() - entry.createdAt > ORDER_LIST_CACHE_TTL_MS) {
    entry = { createdAt: Date.now(), rows: [], cursor: null, hasMore: true, started: false, error: "", request: null, listeners: new Set() };
    entries.set(key, entry);
    if (entries.size > 20) entries.delete(entries.keys().next().value);
  }
  return entry;
}
export function notifyOrderList(entry) { entry.listeners.forEach(listener => listener()); }
export async function fillOrderList(entry, target, fetchPage) {
  if (entry.request) return entry.request;
  if (!entry.hasMore || entry.rows.length >= target || entry.error) return;
  entry.request = (async () => {
    try {
      while (entry.hasMore && entry.rows.length < target) {
        const page = await fetchPage(entry.cursor);
        const ids = new Set(entry.rows.map(order => order.id));
        entry.rows = [...entry.rows, ...page.orders.filter(order => !ids.has(order.id))];
        entry.cursor = page.nextCursor;
        entry.hasMore = Boolean(page.hasMore && page.nextCursor);
        entry.started = true;
        notifyOrderList(entry);
        if (entry.listeners.size === 0) break;
      }
    } catch (error) {
      entry.error = error.message;
      entry.started = true;
    } finally {
      entry.request = null;
      notifyOrderList(entry);
    }
  })();
  notifyOrderList(entry);
  return entry.request;
}
